
import React, { useReducer } from 'react';
import historyReducer from '../reducers/historyReducer';
import mdicon from '../assets/images/mdicon.ico';
const HistoryStateContext = React.createContext();
const HistoryDispatchContext = React.createContext();

export { HistoryStateContext, HistoryDispatchContext };
const initialState = {
  first: {
    current: {
      id: 'freedom',
      // icon: mdicon,
      url: 'https://xn-----8kcbdbp0ap3bibee5azf6m.xn--p1ai',
      title: 'Freedom'
    },
    back: [
      {
        id: 'maddevs',
        url: 'https://maddevs.io',
        title: 'Mad Devs'
      },
      {
        id: 'nambataxi',
        url: 'https://nambataxi.kg',
        title: 'Namba Taxi'
      },
      {
        id: 'counterpart',
        url: 'https://counterpart.org',
        title: 'Counterpart International'
      },
      {
        id: 'viasystems',
        url: 'http://ikeen.com',
        title: 'Via Systems'
      }
    ],
    next: []
  },
  second: {
    current: {
      id: 'new:tab1',
      url: '',
      title: 'New Tab'
    },
    next: [],
    back: []
  }
}
export default function HistoryProvider({ children }) {
  const [state, dispatch] = useReducer(historyReducer, initialState);
  return (
    <HistoryDispatchContext.Provider value={dispatch}>
      <HistoryStateContext.Provider value={state}>
        {children}
      </HistoryStateContext.Provider>
    </HistoryDispatchContext.Provider>
  );
};
